import Box from '@amzn/meridian/box';
import Divider from '@amzn/meridian/divider';
import Heading from '@amzn/meridian/heading';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import { FeedbackCardsRow } from './FeedbackRow';
import ResourceHubAnnouncements from './ResourceHubAnnouncements';

const ResourceHub: React.FC = () => {
  return (
    <div>
      <Box>
        <Heading level={1} type='h600'>
          <FormattedMessage
            id='cs_perfportal_resource_center'
            defaultMessage='Resource Center'
          />
        </Heading>
        <Divider spacingBefore='400' spacingAfter='400' />
      </Box>
      <Heading level={2} type='h500'>
        <FormattedMessage
          id='cs_perfportal_provide_feedback'
          defaultMessage='Provide Feedback'
        />
      </Heading>
      <FeedbackCardsRow />

      <Divider size='medium' spacingBefore='400' spacingAfter='500' />
      <Heading level={2} type='h500'>
        <FormattedMessage
          id='cs_perfportal_announcements'
          defaultMessage='Announcements'
        />
      </Heading>
      <Divider spacingBefore='400' spacingAfter='400' />
      <ResourceHubAnnouncements />
    </div>
  );
};

export default ResourceHub;
